exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#wacg-wrapper .white--text{color:#fff!important}", ""]);

// exports
